<template>
    <div class="card" :class="[color.toLowerCase(), { wildcard: isWildcard }]">
      <div v-if="isWildcard" class="card-wildcard">-</div>
      <div v-else class="card-number">{{ number }}</div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      number: {
        type: Number,
        default: 0
      },
      color: {
        type: String,
        default: 'BLACK'
      },
      isWildcard: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  .card {
    width: 60px;
    height: 90px;
    border-radius: 5px;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .card.black {
    background-color: #333;
    color: white;
  }
  
  .card.white {
    background-color: #fff;
    color: #333;
    border: 1px solid #ccc;
  }
  
  .card.wildcard {
    background-color: #555;
  }
  
  .card-number {
    font-size: 24px;
    font-weight: bold;
  }
  
  .card-wildcard {
    font-size: 32px;
    color: white;
  }
  </style>